//link the information extracted from pdic.action (or other location) to the analytics pages

var getOrSetPageMetaDataAttrElement = function(dataAttrName, val) {
    var metaData = document.getElementsByClassName('page-meta-data');
    metaData = metaData && metaData.length > 0 ? metaData[0] : null;

    if (!metaData) {
        return null;
    }

    if (!dataAttrName) {
        return null;
    }

    // get
    if (typeof val === 'undefined') {
        metaData = metaData.getAttribute(dataAttrName);
    }
    // set
    else {
        metaData.setAttribute(dataAttrName, val);
    }

    return metaData;
};

var getPageMappingFromMetaDataElement = function(dataAttrName) {
    var metaData = getOrSetPageMetaDataAttrElement(dataAttrName);
    var mapping;
    if (metaData) {
        try {
            mapping = JSON.parse(metaData);
            if (!mapping) {
                // eslint-disable-next-line no-console
                console.log('Error - there was an empty page meta data element on the page !!');
            }
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.log('Error - while parsing a JSON attribute of a page meta data !!');
            // eslint-disable-next-line no-console
            console.log(e);
        }
    }
    else {
        // eslint-disable-next-line no-console
        console.log('Error - there was a missing page meta data element on the page !!');
    }
    return mapping;
};

const PAGE_MAPPING = getPageMappingFromMetaDataElement('data-page-type-mapping');

module.exports = {
    PAGE_MAPPING: PAGE_MAPPING,
    getOrSetPageMetaDataAttrElement: getOrSetPageMetaDataAttrElement,
    getPageMappingFromMetaDataElement: getPageMappingFromMetaDataElement
};



// WEBPACK FOOTER //
// ./cartridges/app_bata_sfra/cartridge/client/default/js/pageMetaDataUtils.js